import { AboutPageGeneralDirectorBannerModel } from "@admin/domain/uniquePages/models/AboutPageModel";
import Modal from "react-bootstrap/Modal";
import { Alert } from "react-bootstrap";
import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import { initLanguageMap, Language } from "@admin/domain/languages/helpers";
import { FileModel } from "@admin/domain/files/model/FileModel";
import { useLanguageContext } from "@admin/components/LanguagesContext";
import Input from "@admin/components/Input";
import MultiLanguages from "@admin/components/MultiLanguage";
import ImageInput from "@admin/components/ImageInput";

type Props = {
    showModal: boolean;
    closeModal: () => void;
    onSubmit: (data: AboutPageGeneralDirectorBannerModel) => void;
    editableBanner?: AboutPageGeneralDirectorBannerModel;
};

export default function AboutPageGeneralDirectorModal(props: Props) {
    const languageContext = useLanguageContext();
    const [banner, setBanner] = useState<AboutPageGeneralDirectorBannerModel>(
        props.editableBanner || {
            id: uuid(),
            text: initLanguageMap(),
            file: null,
        },
    );

    const [errors, setErrors] = useState<string[]>([]);
    const submit = () => {
        const newErrors: string[] = [];
        if (!banner.file) newErrors.push(`Изображение обязательно`);
        for (const language of languageContext.availableLanguages) {
            if (!banner.text[language]) newErrors.push(`Поле "${language} Текст" обязательно для заполнения`);
        }
        if (newErrors.length > 0) {
            setErrors(newErrors);
            return;
        }

        props.onSubmit({ ...banner, file: banner.file as FileModel });
        props.closeModal();
    };

    return (
        <Modal centered show={props.showModal} onHide={props.closeModal}>
            <Modal.Header>
                <Modal.Title>
                    {props.editableBanner ? `Обновление` : `Добавление`}
                    {` `}
                    слайдера
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errors.length > 0 && (
                    <Alert variant="danger">
                        {errors.map((err, index) => (
                            <div key={index}>{err}</div>
                        ))}
                    </Alert>
                )}
                <div className="d-flex align-items-center justify-content-center">
                    <ImageInput
                        label="Изображение"
                        name=""
                        defaultValue={banner.file}
                        onChange={(file) => setBanner({ ...banner, file })}
                        width="660px"
                        height="475px"
                    />
                </div>

                <MultiLanguages
                    languageElement={(language: Language) => (
                        <Input
                            label="Текст"
                            onChange={(event) => {
                                setBanner({
                                    ...banner,
                                    text: {
                                        ...banner.text,
                                        [language]: event.target.value,
                                    },
                                });
                            }}
                            value={banner.text[language]}
                        />
                    )}
                />
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" type="button" onClick={props.closeModal}>
                    Закрыть
                </button>
                <button className="btn btn-primary" type="button" onClick={submit}>
                    {props.editableBanner ? `Обновить` : `Добавить`}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
